'use client'

import { useState } from 'react'
import { Bug } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { BugReportModal } from '@/components/bug-report-modal'

export function BugReportButton() {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Button className="w-fit" onClick={() => setOpen(true)}>
        <Bug className="h-4 w-4" />
        Open bug report
      </Button>
      <BugReportModal open={open} onClose={() => setOpen(false)} />
    </>
  )
}
